import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, vShow as _vShow, withModifiers as _withModifiers, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["onDrop"]
const _hoisted_2 = { class: "relative w-full h-full flex justify-center items-end p-8" }
const _hoisted_3 = { class: "absolute flex items-center rounded bg-grey-darkest text-white px-5 py-4" }
const _hoisted_4 = { key: 1 }

import { ref, onMounted, onUnmounted } from 'vue'
import { useI18n } from 'vue-i18n'
import notify from '../plugins/notify'


export default /*#__PURE__*/_defineComponent({
  props: {
  hintLabel: {
    type: String,
    default: '',
  },
  height: {
    type: String,
    default: '100%',
  },
  width: {
    type: String,
    default: '100%',
  },
},
  emits: ['files-dropped'],
  setup(__props, { emit }) {

const { t } = useI18n()





const isDragging = ref(false)
let isDraggingTimeout: ReturnType<typeof setTimeout>

function setDraggingTimeout () {
  isDraggingTimeout = setTimeout(() => {
    isDragging.value = false
  }, 50)
}

function isFileDrag (e: DragEvent) {
  return e.dataTransfer?.items.length && e.dataTransfer?.items[0].kind === 'file'
}

function handleDragEnter (e) {
  if (isFileDrag(e)) {
    isDragging.value = true
    clearTimeout(isDraggingTimeout)
    e.preventDefault()
  }
}

function handleDragOver (e) {
  if (isFileDrag(e)) {
    isDragging.value = true
    clearTimeout(isDraggingTimeout)
    e.preventDefault()
  }
}

function handleDragLeave (e) {
  setDraggingTimeout()
  e.preventDefault()
}

onMounted(() => {
  document.body.addEventListener('dragenter', handleDragEnter, false)
  document.body.addEventListener('dragover', handleDragOver, false)
  document.body.addEventListener('dragleave', handleDragLeave, false)
})

onUnmounted(() => {
  document.body.removeEventListener('dragenter', handleDragEnter, false)
  document.body.removeEventListener('dragover', handleDragOver, false)
  document.body.removeEventListener('dragleave', handleDragLeave, false)
})

function handleDrop (e) {
  setDraggingTimeout()

  if (!e.dataTransfer.files) {
    notify.error(t('dropzone.invalid_drop_items'))
    return
  }

  emit('files-dropped', [...e.dataTransfer.files])
}

return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_i18n_t = _resolveComponent("i18n-t")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    style: _normalizeStyle(`height: ${__props.height}; width: ${__props.width}`),
    class: _normalizeClass([
      'absolute',
      'inset-x-0',
      'z-10',
      isDragging.value && 'border-2 border-solid border-green bg-green-light-30',
    ]),
    onDrop: _withModifiers(handleDrop, ["prevent"])
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_q_icon, {
          name: "mdi-download-outline",
          class: "mr-5 rotate-180",
          size: "24px"
        }),
        (__props.hintLabel)
          ? (_openBlock(), _createBlock(_component_i18n_t, {
              key: 0,
              keypath: "inri.dropzone.hint",
              tag: "span",
              scope: "global"
            }, {
              default: _withCtx(() => [
                _createElementVNode("b", null, _toDisplayString(__props.hintLabel), 1)
              ]),
              _: 1
            }))
          : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.$t('inri.dropzone.hint_general')), 1))
      ])
    ])
  ], 46, _hoisted_1)), [
    [_vShow, isDragging.value]
  ])
}
}

})